"use client";

import { useApiMutation } from "./useApiMutation";
import { ROUTES } from "@/src/constants/routes";
import type {
  RotateBootstrapKeyRequest,
  RotateBootstrapKeyResponse,
} from "@/src/types/api-key-rotate";

export function useRotateBootstrapKey() {
  return useApiMutation<
    RotateBootstrapKeyResponse,
    RotateBootstrapKeyRequest
  >({
    url: ROUTES.KEYS_ROTATE_BOOTSTRAP,
    method: "post",
  });
}